var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":"fieldset-1","label":"現在のステータス"}},[_c('b-form-select',{attrs:{"options":_vm.items,"disabled":!_vm.isEdit},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }